import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';

import { BreadcrumbComponent } from 'app/components/breadcrumb/breadcrumb.component';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { NgIf } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
    selector     : 'empty-layout',
    templateUrl  : './empty.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone   : true,
    imports      : [FuseLoadingBarComponent, NgIf, RouterOutlet,BreadcrumbComponent],
})
export class EmptyLayoutComponent implements OnDestroy
{
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor()
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
